import {FormElement, FormPage, SpecialMapping} from './WebFormTemplate';
import {CustomFormControl} from '../components/controls/CustomFormControl';
import {FormFAQ} from './api/FormFAQ';

export class CreatedFormInfo {
  constructor(public faq: FormFAQ,
              public formPages: FormPage[],
              public templates: Map<string, FormElement[]>,
              public controls: Map<string, CustomFormControl>,
              public specialMappings: SpecialMapping[]) {
  }
}
